<template>
  <div class="afterSales">
    <div class="h-banner">
      <div class="container">
        <h1>支持与服务</h1>
        <p>云蜂智树为您提供7×24小时的专业服务，以及多样化的支持计划和专家服务，满足您从上云部署、日常运维到优化升级等全周期需求，让您的上云之路更加高效敏捷。</p>
      </div>
    </div>
    <div class="session-1">
      <div class="container">
        <ul class="row">
          <li class="col-md-4">
            <img src="@/assets/images/afterSales/service_images_bg_01.png" alt="">
            <div class="box">
              <span class="tit">7x24小时保障</span>
              <span class="txt">专业保障服务，上云更放心</span>
            </div>
          </li>
          <li class="col-md-4">
            <img src="@/assets/images/afterSales/service_images_bg_02.png" alt="">
            <div class="box">
              <span class="tit">专业技术与服务</span>
              <span class="txt">降低成本和风险，对接更顺畅</span>
            </div>
          </li>
          <li class="col-md-4">
            <img src="@/assets/images/afterSales/service_images_bg_03.png" alt="">
            <div class="box">
              <span class="tit">全周期服务</span>
              <span class="txt">售后跟踪，全程服务，更贴心</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="session-2">
      <div class="container">
        <ul class="row">
          <li class="col-sm-6">
            <img src="@/assets/images/afterSales/service_icon_01.png" alt="">
            <div class="tit">咨询与设计</div>
            <div class="txt">提供业务资讯和评估支持，充分理解之后再自助使用</div>
          </li>
          <li class="col-sm-6">
            <img src="@/assets/images/afterSales/service_icon_02.png" alt="">
            <div class="tit">在线客服</div>
            <div class="txt">提供专业务客服，为您提供技术的服务</div>
            <div class="txt-s">客服时间：09:30-18:30 工作日</div>
          </li>
          <li class="col-sm-6">
            <img src="@/assets/images/afterSales/service_icon_03.png" alt="">
            <div class="tit">迁移与部署</div>
            <div class="txt">具备丰富的交付经验和能力，提供产品体系的端到端系统上云服务</div>
          </li>
          <li class="col-sm-6">
            <img src="@/assets/images/afterSales/service_icon_04.png" alt="">
            <div class="tit">帮助文档</div>
            <div class="txt">提供详细的帮助文档，通过自助即可使用</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.h-banner{
  color: #fff;
  background: url('../assets/images/afterSales/service_images_bg_top.png') no-repeat;
  background-size: cover;
  background-position: center;
  height: 500px;
  text-align: center;
  h1{
    font-size: 36px;
    font-weight: bold;
    margin-top: 302px;
  }
  p{
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 70px;
    margin-left: auto;
    margin-right: auto;
    max-width: 870px;
  }
}
.session-1{
  margin-top: 100px;
  ul{
    li{
      position: relative;
      img{
        width: 100%;
        display: block;
      }
      .box{
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        transform: translateY(-50%);
        color: #fff;
        text-align: center;
        .tit{
          display: block;
          font-size: 28px;
          font-weight: bold;
        }
        .txt{
          display: block;
          font-size: 18px;
          margin-top: 6px;
        }
      }
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-1{
    margin-top: 40px;
  }
}
.session-2{
  ul{
    margin-bottom: 160px;
    li{
      text-align: center;
      margin-top: 114px;
      img{
        width: 80px;
        height: 80px;
        margin: 0 auto;
        display: block;
      }
      .tit{
        font-size: 18px;
        font-weight: bold;
        margin-top: 40px;
      }
      .txt{
        font-size: 14px;
        margin-top: 10px;
      }
      .txt-s{
        font-size: 12px;
        color: #999999;
        margin-top: 5px;
      }
    }
  }
}
@media (max-width: $screen-sm-min) {
  .session-2{
    ul{
      margin-bottom: 40px;
      li{
        margin-top: 40px;
        .tit{
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
